import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PATTERNS } from '../../../shared/constants/patterns.constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../../shared/services/util.service';
import { ApiService } from '../../../shared/services/api.service';
import { UserModal } from '../user.model';
import { ImageService } from '../../../shared/services/image.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  standalone: false,
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent {

  @Input() newUser: any;
  @Output() onSave = new EventEmitter<boolean>();
  errorMessage = '';
  depts: any;
  roles = [];
  pattern = PATTERNS;
  error: Boolean = false;

  constructor(private activeModal: NgbActiveModal,
    private _util: UtilService,
    private _apiService: ApiService,
    private _imageService: ImageService,
    private _auth: AuthService
  ) { }

  ngOnInit() {
    const vm = this;
    const user = vm._auth.getUser();
    if (vm.newUser && vm.newUser._id) {
      if (!vm.newUser.username && vm.newUser.name) {
        vm.newUser.username = vm.newUser.name;
      }
    } else {
      vm.newUser = new UserModal();
      vm.newUser.partnerId = user?.partnerId?._id;
      vm.newUser.status = 'Active';
    }
  }

  onDepartmentChange() {
    this.newUser.role = '';
    this.roles = this.depts.find((d: any) => d && d.dept === this.newUser.department).roles;
  }

  onUpload(fileInput: any) {
    const vm = this;
    const file = fileInput.target.files[0];
    if (file) {
      vm._imageService.readDoc(fileInput, (res) => {
        if (res) {
          vm._imageService.uploadDocAPICall(res, (cb) => {
            if (cb) {
              vm.newUser.logoPath = cb;
            }
          });
        } else {
          
        }
      });
    }
  }

  viewDoc(id) {
    const vm = this;
    vm._imageService.fetchAndViewDoc(id);
  }

  onDelete(id) {
    const vm = this;
    vm._imageService.deleteDoc(id, () => {
      vm.newUser.logoPath = "";
    });
  }

  onClose() {
    const vm = this;
    vm.activeModal.close(true);
  }

  onSubmit() {
    const vm = this;
    vm.error = false;
    const payload: any = {
      name: vm.newUser.name,
      email: vm.newUser.email,
      mobile: vm.newUser.mobile,
      department: vm.newUser.department,
      role: vm.newUser.role,
      status: vm.newUser.status,
      partnerId: vm.newUser.partnerId,
    };
    if (vm.newUser.logoPath) payload.logoPath = vm.newUser.logoPath;
    if (vm.newUser.password) payload.password = vm.newUser.password;
    if (vm.newUser._id) payload._id = vm.newUser._id;
    const apiUrl = vm.newUser._id ? '/partners/auth/partner-users/update' : '/partners/auth/partner-users/create';
    vm._apiService.postData(apiUrl, payload).subscribe((res: any) => {
      if (res && !res.error) {
        vm.activeModal.close(true);
        vm.onSave.emit();
        vm._util.navigate('/app/users');
      } else {
        vm.errorMessage = 'EmailID already exist please use another one';
      }
    });
  }

}
